export { default } from './HeroBanner.js'
